
import { Vue, Component, Prop } from 'vue-property-decorator'
import AdManageApi from '@/apis/advertManage/admanage';
import samllProgram from "@/views/KtpActivity/ad/smallProgram.vue";
import {isWechat} from '@/utils/common';
import { Toast } from 'vant';
import Swiper from "swiper";
import SwiperCore, { Autoplay, FreeMode, Scrollbar, Mousewheel, Pagination } from "swiper";
SwiperCore.use([Autoplay, FreeMode, Scrollbar, Mousewheel, Pagination]);

//正在学习的课程
@Component({
  name: 'BannerAdLists',
  components: {
    samllProgram
  },
})
export default class BannerAdLists extends Vue {
    @Prop(Number) readonly locationIndex !: number

    isWechat = isWechat;

    private change:string = '0';
    private maxShowCount:number = 5;
    private canshow:boolean = false;

    private commendLists = [];
    private totalCommendCount = 0;
    private showMoreBtn:boolean = true;
    private explandState = 0;//0表示展开 1表示收起
    private impressionsMap = new Map();//是否被曝光过

    private mySwiperObj:any = null;

    private samllProgramData:any = {
      show:false,
      username:'',
      path:'',
      btnName:'',
    };

    created() {

    }
    
    mounted(){
        this.getAdList();
    }

    slideChange(realIndex:number){
        let item:any = this.commendLists[realIndex];
        if(item){
            //如果曝光过的就不要重复曝光
            if(!this.impressionsMap.get(item.id)){
                AdManageApi.collectAdLog({adid:item.id,corpid:item.corpid,type:1,location:0}).then((res1:any)=>{});
                this.impressionsMap.set(item.id,1);
            }
        }
    }

    getAdList(){
        AdManageApi.getAdByLocation({ location: this.locationIndex, maxShowCount:this.maxShowCount}).then((res:any)=>{
           this.commendLists = res.adLists;
           this.totalCommendCount = res.adLists.length;
           if(this.totalCommendCount<=3){
            this.showMoreBtn = false;
           }
           if(this.commendLists && this.commendLists.length>0){
                this.canshow = true;
                this.slideChange(0);
           }
           if(this.commendLists && this.commendLists.length>0){
            AdManageApi.collectPageLog({location:0});
           }
        });
    }

    /**
     * 点击的跳转的处理
     */
    gotoItem(item:any){
        AdManageApi.collectAdLog({adid:item.id,corpid:item.corpid,type:2,location:0}).then((res1:any)=>{
            if(item.jumptype == 2 && item.jumpurl != ""){
                this.openNewWindow(item.jumpurl);
            }else if(item.jumptype == 3 && item.jumpurl != ""){
                if(!isWechat){
                Toast("请使用微信进行打开...");
                }else{
                this.samllProgramData = {
                    show:true,
                    username:item.smallprogramid,
                    path:item.jumpurl,
                    btnName:'点击前往小程序',
                };
                }
            }
        });
    }

    /**
     * 变化处理
     */
    onSwipeChange(index:number){
        console.log("onSwipeChange index:"+index);
    }

    onCloseSmallProgram(){
      this.samllProgramData.show = false;
    }
}
